import styled from "styled-components";

export const MainLayout = styled.div`
    padding: 5rem;
    @media screen and (max-width: 500px) {
        padding: 2rem;
    }
`;

export const InnerLayout = styled.div`
    padding: 5rem 0;
`;